import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { FormFixedResponse } from './form-fixed-response.model';

export const loadFormFixedResponses = createAction(
  '[FormFixedResponse/API] Load FormFixedResponses',
  props<{ formFixedResponses: FormFixedResponse[] }>()
);

export const addFormFixedResponse = createAction(
  '[FormFixedResponse/API] Add FormFixedResponse',
  props<{ formFixedResponse: FormFixedResponse }>()
);

export const upsertFormFixedResponse = createAction(
  '[FormFixedResponse/API] Upsert FormFixedResponse',
  props<{ formFixedResponse: FormFixedResponse }>()
);

export const addFormFixedResponses = createAction(
  '[FormFixedResponse/API] Add FormFixedResponses',
  props<{ formFixedResponses: FormFixedResponse[] }>()
);

export const upsertFormFixedResponses = createAction(
  '[FormFixedResponse/API] Upsert FormFixedResponses',
  props<{ formFixedResponses: FormFixedResponse[] }>()
);

export const updateFormFixedResponse = createAction(
  '[FormFixedResponse/API] Update FormFixedResponse',
  props<{ formFixedResponse: Update<FormFixedResponse> }>()
);

export const updateFormFixedResponses = createAction(
  '[FormFixedResponse/API] Update FormFixedResponses',
  props<{ formFixedResponses: Update<FormFixedResponse>[] }>()
);

export const deleteFormFixedResponse = createAction(
  '[FormFixedResponse/API] Delete FormFixedResponse',
  props<{ id: string }>()
);

export const deleteFormFixedResponses = createAction(
  '[FormFixedResponse/API] Delete FormFixedResponses',
  props<{ ids: string[] }>()
);

export const clearFormFixedResponses = createAction(
  '[FormFixedResponse/API] Clear FormFixedResponses'
);


export const createFormFixedResponseMutation = createAction(
  '[FormFixedResponse/API] Create FormFixedResponse',
  props<{ input: any }>()
)

export const updateFormFixedResponseMutation = createAction(
  '[FormFixedResponse/API] UpdateMutation FormFixedResponse',
  props<{ input: any }>()
)

export const getFormFixedResponse = createAction(
  '[FormFixedResponse/API] Get FormFixedResponse',
  props<{ filtering: any }>()
)

export const deleteFormFixedResponseMutation = createAction(
  '[FormFixedResponse/API] DeleteMutation FormFixedResponse',
  props<{ uniqueId: string, id: string }>()
)
